import React, { Component, PropTypes } from 'react';
import ReactSparkTextInput from '../../../widgets/ReactSparkTextInput';
import { connect } from 'react-redux';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { RemFilter } from '../../../helpers/RemFilter';
import { actions as ThemeActions } from '../../../../store/ThemeStore';

class PageTitleFaviconStyles extends Component {
    render() {
        return (
            <div>
                <h4>Favicon URL</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-3 col-lg-12 top-margin">
                        <ReactSparkTextInput
                            label="Favicon URL"
                            isDisabled={this.props.isDisabled}
                            value={this.props.page.favicon}
                            onChange={this.props.onThemePropChange('favicon')}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapHeaderStylesStateToProps = (state, ownProps) => ({ page: state.app.data.theme.page });

const mapHeaderStylesDispatchToProps = dispatch => ({
    onThemePropChange: onThemePropChange(dispatch, 'page')
});

export default connect(mapHeaderStylesStateToProps, mapHeaderStylesDispatchToProps)(PageTitleFaviconStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/PageTitleFaviconStyles.js